import './ChartTooltip.scss';
import cn from 'classnames';
import { JSX, ReactNode } from 'react';

export interface PayloadItem {
  label: ReactNode;
  value: string | number | undefined;
  color: string | undefined;
  shape?: string;
  svgIcon?: JSX.Element;
  iconClassName?: string;
}

interface ChartTooltipProps {
  headerLabel: string | JSX.Element;
  items: PayloadItem[];
  shape?: 'circle' | 'square' | 'line';
  reverseItems?: boolean;
  colonSeparator?: boolean;
  className?: string;
}

export const ChartTooltip = ({
  headerLabel,
  items,
  shape = 'square',
  reverseItems,
  colonSeparator = true,
  className
}: ChartTooltipProps) => {
  const displayedItems = reverseItems ? [...items].reverse() : items;
  return (
    <div className={cn('chart-tooltip', className)}>
      <div className='header-label'>{headerLabel}</div>
      <div className='item-list'>
        {displayedItems.map((item, i) => {
          const { label, value, color } = item;
          if (!value && value !== 0) {
            return null;
          }
          return (
            <div className='item-row' key={i}>
              {item.svgIcon ? (
                <div className='tooltip-svg-icon-custom'>
                  <svg viewBox='0 0 16 12' preserveAspectRatio='none'>
                    {item.svgIcon}
                  </svg>
                </div>
              ) : (
                <div
                  className={cn(item.shape ?? shape, item.iconClassName)}
                  style={{ backgroundColor: color }}
                />
              )}
              <div className='name'>
                {label}
                {colonSeparator ? ': ' : ' '}
              </div>
              <div className='value'>{value}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
